var React = require('react');

function IcPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.5 0V14L11.5 7L0.5 0Z","fill":"currentColor"}));
}

IcPlay.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14","fill":"currentColor"};

module.exports = IcPlay;

IcPlay.default = IcPlay;
